(function($) {

	'use strict';

	var init = function() {

        if($('.flex-timeline').length > 0) {

            startTimeline();

            $(window).resize(function() {
                $('.flex-timeline__repeater').removeClass('active');
                $('.dash').each(function() {
                    $(this).remove();
                });
                $('.circle').each(function() {
                    $(this).remove();
                });
                startTimeline();
            });

        }

	};

	var startTimeline = function() {

        $('.flex-timeline__repeater').css('height', 'auto');

        var resetHeight = function() {
            $('.flex-timeline__item').each(function() {
                $(this).css('height', 'auto');
            });
            newHeight();
        }

        var newHeight = function() {
            $('.flex-timeline__item').each(function() {
                $(this).css('height', Math.ceil($(this).height()) + 'px');
            });
        }

        resetHeight();

        if($(window).width() > 767) {

            $('.flex-timeline__bloc').each(function(index) {
                if(index % 2 == 0) {
                    $(this).css('margin-bottom', '250px');
                }
            });

            var blocMargin =  function() {
                $('.flex-timeline__bloc').each(function(index) {
                    if(index % 2 == 0) {
                        var offset = $('.flex-timeline__bloc:eq(' + (index + 1) + ')').height() / 2;
                        $('.flex-timeline__bloc:eq(' + index + ')').css('margin-bottom', offset + 'px');
                    }
                });
                setupHeight();
            }

            var setupDash = function() {
                $('.flex-timeline__repeater').each(function() {

                    var $timeline = $(this);
    
                    var blocs = [];
    
                    $timeline.find('.flex-timeline__bloc').each(function() {
                        blocs.push($(this).offset().top - $timeline.offset().top);
                    });
    
                    for(var i = 0; i < (($timeline.outerHeight() - ($timeline.find('.flex-timeline__bloc').height() / 2)) / 26); i++) {
                        var offset = i * 26;
                        var dash = true;
                        for(var j in blocs) {
                            if(blocs[j] >= (i * 26) && blocs[j] < ((i + 1) * 26)) {
                                dash = false;
                            }
                        }
                        if(dash) {
                            $timeline.append('<span class="dash" style="top:' + offset + 'px"></span>');
                        } else {
                            $timeline.append('<span class="circle" style="top:' + offset + 'px"></span>');
                        }
                        
                    }
    
                });
            }

            var setupHeight = function() {
                if($('.flex-timeline__bloc').length % 2 == 0) {
                    $('.flex-timeline__repeater').css('height', ($('.flex-timeline__repeater').outerHeight()) + 'px');
                } else {
                    $('.flex-timeline__repeater').css('height', ($('.flex-timeline__repeater').outerHeight() - $('.flex-timeline__item:last').height() / 1.5) + 'px');
                }
                setupDash();
            }

            blocMargin();

        } else {

            $('.flex-timeline__bloc').each(function() {
                $(this).css('margin-bottom', 0);
            });

            $('.flex-timeline__repeater').each(function() {

                var $timeline = $(this);

                $timeline.find('.flex-timeline__bloc').each(function(index) {
                    if(index > 0) {
                        var top = $(this).offset().top - $timeline.offset().top;
                        $('<span class="dash" style="top:' + (top - 78) + 'px"></span><span class="circle" style="top:' + (top - 52) + 'px"></span><span class="dash" style="top:' + (top - 26) + 'px"></span>').insertBefore($(this));
                    }
                });

            });

            $('.flex-timeline__repeater').css('height', 'auto');

        }

        $('.flex-timeline__repeater').addClass('active');

	}

	$(window).on('load', function() {
        init();
    });

})(jQuery);